



















import { Component, Ref, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

import AgenciesCustomReportExporter from "@/components/Agencies/CustomReportExporter.vue";
import GrpTargetSelect from "@/components/GrpTargetSelect.vue";
import PageGuide, { GuidePaths } from "@/components/PageGuide.vue";

import { Target, AdcontrolProfile } from "@/models";
import CompetitorsReportRecord from "@/models/interfaces/Competitors";

@Component({
  components: {
    GrpTargetSelect,
    AgenciesCustomReportExporter,
    PageGuide,
  },
})
export default class CustomReport extends Vue {
  currentGrpTarget: Target | null = null;

  data: CompetitorsReportRecord[] = [];

  loading = false;

  @Getter("profile") readonly profile!: AdcontrolProfile;
  @Ref("exporter") readonly exporter!: AgenciesCustomReportExporter;

  guidePath = GuidePaths.AGENCIES_CUSTOM_REPORT;

  onRestartClick() {
    this.exporter?.restart();
  }

  get isTv(): boolean {
    return this.profile.accountType === "tv";
  }

  async onTargetSelected(target: Target) {
    this.currentGrpTarget = target;
  }

  get grpTargetId() {
    if (this.currentGrpTarget && this.isTv) return this.currentGrpTarget?.id;
    else return null;
  }
}
